import { normalizeEmployeeLogin } from "@/lib/auth";

export interface HeroEmployeeRecord {
  id?: number;
  user_id?: number;
  login?: string | null;
  name?: string | null;
  full_name?: string | null;
  email?: string | null;
  account_type?: string | null;
  initials?: string | null;
  profile_image_url?: string | null;
  status?: string | null;
  is_nachunternehmer?: boolean;
}

export function employeeLoginFromRecord(employee: HeroEmployeeRecord): string {
  const email = String(employee.email || "").trim();
  if (email) return normalizeEmployeeLogin(email);
  const login = String(employee.login || "").trim();
  if (login) return normalizeEmployeeLogin(login);
  const userId = employee.user_id;
  if (userId != null) return normalizeEmployeeLogin(String(userId));
  return "";
}

export function employeeDisplayFromRecord(employee: HeroEmployeeRecord): string {
  return (
    String(employee.full_name || employee.name || "").trim() ||
    String(employee.email || "").trim() ||
    (employee.user_id != null ? String(employee.user_id) : "")
  );
}

export function employeeAccountTypeLabel(accountType: string | null | undefined): string {
  const t = String(accountType || "").trim().toLowerCase();
  if (t === "mobile") return "Mobile";
  if (t === "full") return "Voll-Lizenz";
  if (!t) return "—";
  return accountType || "—";
}

export function encodeEmployeeLoginParam(login: string): string {
  return encodeURIComponent(login);
}

export function decodeEmployeeLoginParam(login: string): string {
  return normalizeEmployeeLogin(decodeURIComponent(login));
}
